import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import SidebarBody from './SidebarBody/SidebarBody'
import SidebarHeader from './SidebarBody/SidebarHeader'
import { converterTable, currencySidesLocal, currencySidesTargetsLocal } from '../../config'
import { getGetSide, getTargetAssetName } from '../../helpers'
import { useDefaultComponentTools } from '../../hooks/useDefaultComponentTools'
import {
	selectAssetSoId,
	selectAssetTitle,
	selectLatestRatesItem,
	selectLotSize,
	selectMainConversionAssets,
	selectPipDecimalPlaces,
	selectSelectedAsset
} from '../../store/redusers/assets/selectors'
import { setPipValue, setUsedMargin } from '../../store/redusers/orders/actions'
import {
	selectIsSunday,
	selectLeverage,
	selectLotCountData
} from '../../store/redusers/orders/selectors'
import {
	selectComplexLeverage,
	selectLastUsdPrice,
	selectMarginTradePlatform,
	selectUserCurrency,
	selectCurrencySides,
	selectCurrencySidesTargets
} from '../../store/redusers/user/selectors'
import TradingService from '../../tradingService'


const Sidebar = ({depositHeight}) => {
	const asset = useSelector(selectSelectedAsset) || ''
	const { dispatch, mdUp, theme } = useDefaultComponentTools(true)
	const isSunday = useSelector(selectIsSunday)
	const marginTrade = useSelector(selectMarginTradePlatform)
	const lotCountData = useSelector(selectLotCountData)
	const assetTitle = useSelector(selectAssetTitle(asset.assetType, asset.assetSoId))
	const soId = useSelector(selectAssetSoId(asset.assetType, asset.assetSoId))
	const currencySides = useSelector(selectCurrencySides)
	const currencySidesTargets = useSelector(selectCurrencySidesTargets)
	//only for local work
	const currentSide = currencySides ? getGetSide(currencySides, +soId) : getGetSide(currencySidesLocal, +soId)
	const assetTargetForex  = currencySides ? currencySidesTargets[currentSide] : currencySidesTargetsLocal[currentSide]
	const lastUsdPrice = useSelector(selectLastUsdPrice)
	const pipDecimalPlaces = useSelector(selectPipDecimalPlaces(asset.assetType, asset.assetSoId))
	const latestRatesAssetSoId = useSelector(selectLatestRatesItem(asset.assetSoId))
	const targetAssetName = getTargetAssetName(assetTitle, asset.assetType)
	const targetNameAsset = targetAssetName.trim()
	const loginUserCurrency = useSelector(selectUserCurrency)
	const mainConversionAssets = useSelector(selectMainConversionAssets)
	const loginCurrencyUser = loginUserCurrency.trim().substring(0, 3)
	const detailConvertFromCurrency = converterTable[targetNameAsset]
	const detailConvertUserCurrency = converterTable[loginCurrencyUser]
	const latestRatesDetailConvertFromCurrency =
		useSelector(selectLatestRatesItem(detailConvertFromCurrency ?
			'asset_' + detailConvertFromCurrency['soId'] : null))
	const latestRatesDetailConvertUserCurrency =
		useSelector(selectLatestRatesItem(detailConvertUserCurrency ?
			'asset_' + detailConvertUserCurrency['soId'] : null))
	const complexLeverage = useSelector(selectComplexLeverage)
	const latestRatesAssetTargetForex  =
		useSelector(selectLatestRatesItem(assetTargetForex ? 'asset_' + assetTargetForex[0] : null))
	const latestRatesAsset  =
		useSelector(selectLatestRatesItem(asset.assetSoId))
	const assetLotSize = useSelector(selectLotSize(soId))
	const leverage = useSelector(selectLeverage)

	useEffect(() => {
		const tradingService = new TradingService({
			assetLotSize,
			assetTargetForex,
			assetTitle,
			assetType: asset.assetType,
			complexLeverage,
			dispatch,
			isSunday,
			lastUsdPrice,
			latestRatesAsset,
			latestRatesAssetSoId,
			latestRatesAssetTargetForex,
			latestRatesDetailConvertFromCurrency,
			latestRatesDetailConvertUserCurrency,
			leverage,
			loginUserCurrency,
			lotCountData,
			mainConversionAssets,
			marginTrade,
			pipDecimalPlaces,
			soId
		})
		tradingService.refreshPipValue().then(pipValue => {
			dispatch(setPipValue(pipValue.toPrecision(9).toString()))
		})
		tradingService.conversionCal().then(usedMargin => {
			dispatch(setUsedMargin(usedMargin.toPrecision(7).toString().slice(0,7))
			)
		})
	}, [asset, lotCountData[soId], latestRatesAssetSoId, selectUserCurrency])

	return (
		<Box sx={{
			borderLeft: theme.palette.border,
			height: mdUp ? `calc(100vh - ${depositHeight + 'px'})` : '100vh',
			overflow: 'auto',
			padding: '16px'
		}}>
			<SidebarHeader />
			<SidebarBody />
		</Box>
	)
}

Sidebar.propTypes = {
	depositHeight: PropTypes.number
}

export default Sidebar
